import React, { useEffect, useRef, useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    CircularProgress,
    Divider,
    FormControl,
    FormControlLabel,
    Checkbox,
    FormGroup,
} from "@mui/material";
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { pdfjs } from 'react-pdf';
import { Button, Sheet, Stack } from "@mui/joy";
import { BsFiletypePdf } from "react-icons/bs";

// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;


export default function PolicyAgreement({ open, onClose, policy, onAccept }) {
    const [numPages, setNumPages] = useState(null);
    const [pageWidth, setPageWidth] = useState(900);
    const [checkState, setCheckState] = useState({
        term1: false,
        term2: false,
    });
    const { term1, term2 } = checkState;

    const [loading, setLoading] = useState(true);
    const previewRef = useRef(null);
    const containerRef = useRef(null);
    const pagesRendered = useRef(0);

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
        setLoading(false);
        pagesRendered.current = 0;
    };

    const onRenderSuccess = () => {
        pagesRendered.current += 1;
    };

    const handleChange = (event) => {
        setCheckState({
            ...checkState,
            [event.target.name]: event.target.checked,
        });
    };

    useEffect(() => {
        if (!containerRef.current) return;

        const observer = new ResizeObserver(() => {
            const width = containerRef.current?.clientWidth;
            if (width) setPageWidth(width + 5); // small padding
        });

        observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        if (open) {
            setCheckState({ term1: false, term2: false });
        }
    }, [open, policy?.url]);

    const download_policy_pdf = () => {
        fetch(policy?.url)
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.blob();
            })
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `Carepassport_HomeDoc_${policy?.policyId}`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch(() => {
                window.open(policy?.url, '_blank');
            });
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            disableScrollLock={true}
            PaperProps={{
                sx: {
                    height: "90vh",
                    display: "flex",
                    flexDirection: "column",
                },
            }}
        >
            <DialogTitle>{"Home Doc Review - " + policy?.title}</DialogTitle>

            <DialogContent
                dividers
                ref={containerRef}
                sx={{ flex: 1, overflow: "hidden", p: 0 }}
            >
                <Box ref={previewRef} sx={{ height: "100%", overflowY: "auto", p: 2, scrollBehavior: "smooth" }}>
                    {loading && (
                        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                            <CircularProgress />
                        </Box>
                    )}
                    <Sheet variant='soft' color='primary'>
                        <Typography variant="body-xs" sx={{ p: 1 }} display="flex" justifyContent="center" alignItems="center">About this Home Doc</Typography>
                        <Typography variant="caption" sx={{ p: 1 }} display="flex" justifyContent="center" alignItems="center">{policy.description}</Typography>
                        <Typography variant="caption" sx={{ p: 1 }} display="flex" justifyContent="center" alignItems="center">Please review and scroll to the bottom of page to Accept</Typography>
                    </Sheet>
                    <Box>
                        <Document
                            file={policy?.url}
                            onLoadSuccess={onDocumentLoadSuccess}
                            onLoadError={(err) => console.error("PDF load error:", err)}
                        >
                            {Array.from(new Array(numPages), (el, index) => (
                                <Page
                                    key={`page_${index + 1}`}
                                    pageNumber={index + 1}
                                    width={pageWidth}
                                    onRenderSuccess={onRenderSuccess}
                                />
                            ))}
                        </Document>
                    </Box>
                    
                    <Divider variant="middle"><Typography variant="overline" gutterBottom>END OF DOCUMENT</Typography></Divider>
                    <br></br>
                    <Box display="flex" justifyContent="center" alignItems="center" p={2}>
                        {
                            (policy?.status !== "Validated")
                                ?
                                <>
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <FormControl sx={{ m: 3 }} component="fieldset" variant="standard">
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={term1} onChange={handleChange} name="term1" />
                                                    }
                                                    label="I hereby attest that I have read the document and understand its content."
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={term2} onChange={handleChange} name="term2" />
                                                    }
                                                    label="I understand that it is my responsibility to raise and address any questions or concerns with the LTC home about the content of this document."
                                                />
                                                <br></br>
                                                <Button variant={(!term1 || !term2) ? "outlined" : "solid"} color="primary" disabled={!term1 || !term2} onClick={onAccept}> Save</Button>
                                            </FormGroup>
                                        </FormControl>
                                    </Stack>
                                </>
                                :
                                <Button variant="outlined" color="primary" disabled={true}> Accepted</Button>
                        }
                    </Box>
                </Box>

            </DialogContent>

            <DialogActions sx={{ justifyContent: "flex-end", float: "right", px: 2 }}>
                <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
                        <Button variant="outlined" color="primary" onClick={download_policy_pdf}>
                            <BsFiletypePdf style={{fontWeight:"1.5rem"}} /> &nbsp; Download Document
                        </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </Box>
            </DialogActions>
        </Dialog>
        
    );
}
